/**
 * Event schedule helpers: date formatting and locale-aware text extraction.
 */

/**
 * Formats a start/end date pair into a human-readable range string.
 * Example: "Apr 14 - 16, 2026"
 */
export const formatEventDates = (startDateStr: string | null, endDateStr: string | null): string => {
    if (!startDateStr || !endDateStr) return '';
    const start = new Date(startDateStr);
    const end = new Date(endDateStr);
    const month = start.toLocaleString('default', { month: 'short' });
    const startDay = start.getDate();
    const endDay = end.getDate();
    const year = start.getFullYear();
    return `${month} ${startDay} - ${endDay}, ${year}`;
};

/**
 * Extracts locale-aware text from a Commercetools localised string object.
 * Falls back to English, then the first available value.
 */
export const getLocText = (val: unknown): string => {
    if (!val) return '';
    if (typeof val === 'object' && val !== null) {
        const obj = val as Record<string, string>;
        return obj['en'] || obj['en-US'] || Object.values(obj)[0] || '';
    }
    return String(val);
};
